import { trackEvent } from '../../../helpers/analytics/trackEvent';
import { EventMykissCardClicked } from '../../../interfaces/events';

export const sendCardClickedEvent = (properties: EventMykissCardClicked['properties']): void => {
  void trackEvent({
    name: 'mykiss_card_clicked',
    properties,
  });
};
